/**
 * @file interset
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'


class Interest extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    return (
      <div id="interest">
        <div className="interest-first">
          <div className="inner-title">趣味课堂</div>
          <div className="interest-bottum">
            <div className="bt-cont">
              <video className="vid" controls poster='//cdn.ihatoo.com/hatu-official/extra/cover.jpg'>
                <source src="//cdn.ihatoo.com/hatu-official/course/video/qwkt.mp4" type="video/mp4" />
              </video>
              <div className="shu" >
                <div className="yuan"></div>
              </div>
              <div className="bt-right">
                <div className="study">
                  <div className="img"></div>
                  <div className="bt-text">
                    <div className="title">课前预习</div>
                    <br />
                    <div className="intro">提前了解课程内容，建立初步印象，上课效率更高</div>
                  </div>
                </div>
                <div className="study1">
                  <div className="img"></div>
                  <div className="bt-text">
                    <div className="title">课堂互动</div>
                    <br />
                    <div className="intro">充分利用孩子注意力集中时间，高频互动，提高开口率</div>
                  </div>
                </div>
                <div className="study2">
                  <div className="img"></div>
                  <div className="bt-text">
                    <div className="title">课后复习</div>
                    <br />
                    <div className="intro">游戏化的复习系统，巩固课堂知识的同时养成良好学习习惯</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Interest